import { Request } from "./HttpService";

export const JobRoleDetailService = {
  getAllBusinessAreas() {
    let url = `vitae/jobroledetail/BusinessArea`;
    return Request(url, "GET").then((data) => {
      return data;
    });
  },
  getAllTechAreas() {
    let url = `vitae/jobroledetail/TechArea`;
    return Request(url, "GET").then((data) => {
      return data;
    });
  },
  getAllTechRoles(techAreaId) {
    let url = `vitae/jobroledetail/TechRole/${techAreaId}`;
    return Request(url, "GET").then((data) => {
      return data;
    });
  },
  getTechSkillsByRole(techRoleId) {
    let url = `vitae/jobroledetail/Tech/${techRoleId}`;
    return Request(url, "GET").then((data) => {
      return data;
    });
  },
  getJobRoleTree() {
    let url = `vitae/techarea/techRoles/technologies`;
    return Request(url, "GET").then((data) => {
      return data;
    });
  }
};
